import { createUseStyles } from "react-jss";
import { palette }         from "_styles/theme";

export default createUseStyles ( theme => ( {
	notificationIconContainer: {
		width       : "100%",
		display     : "flex",
		alignItems  : "center",
		// position    : "relative",
		paddingLeft : "0.5rem"
	},
	notificationCounter: {
		width           : ( { notificationCount } ) => notificationCount > 9 ? "30px" : "15px",
		height          : "15px",
		backgroundColor : theme.paletteNew.tertiaryErrorRed,
		borderRadius    : ( { notificationCount } ) => notificationCount > 9 ? "10px" : "50%",
		padding         : "5px",
		fontSize        : "0.7rem",
		fontWeight      : "bold",
		color           : "#fff",
		display         : "flex",
		alignItems      : "center",
		justifyContent  : "center"
		// position        : "absolute",
		// top             : "10%",
		// right           : "25%"
	}
} ) );

